var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6544 1.95073L9.60514 8L15.6544 14.0493C16.1 14.4948 16.1 15.2203 15.6544 15.6658C15.4316 15.8886 15.1403 16.0029 14.849 16.0029C14.5577 16.0029 14.2663 15.8886 14.0436 15.6658L7.99429 9.61657L1.94502 15.6658C1.72224 15.8886 1.43092 16.0029 1.13959 16.0029C0.848268 16.0029 0.556944 15.8886 0.334166 15.6658C-0.111389 15.2203 -0.111389 14.4948 0.334166 14.0493L6.38343 8L0.334166 1.95073C-0.111389 1.50518 -0.111389 0.779721 0.334166 0.334166C0.779721 -0.111389 1.50518 -0.111389 1.95073 0.334166L8 6.38343L14.0493 0.334166C14.4948 -0.111389 15.2203 -0.111389 15.6658 0.334166C16.1114 0.779721 16.1114 1.50518 15.6658 1.95073H15.6544Z",
    fill: "#474554"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.e1fce61a244934cd46826a934b829e39.svg";
export { ForwardRef as ReactComponent };